import React from "react";
import RxSymbol from "../../../rx.png";

export default function PrescriptionSymbol({ size = 48 }) {
  return (
    <img
      src={RxSymbol}
      alt="Prescription Symbol"
      style={{ width: `${size}px`, height: "auto" }}
    />
  );
}
